import { render, staticRenderFns } from "./DeclarationApprovalForm.vue?vue&type=template&id=b85a383a&scoped=true&"
import script from "./DeclarationApprovalForm.vue?vue&type=script&lang=js&"
export * from "./DeclarationApprovalForm.vue?vue&type=script&lang=js&"
import style0 from "./DeclarationApprovalForm.vue?vue&type=style&index=0&id=b85a383a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85a383a",
  null
  
)

export default component.exports